import React, { useEffect, useState } from "react";
import FsLightbox from "fslightbox-react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../firebase";

// import { db } from "../../firebase";
// import ImageGallery from "react-image-gallery";
// import "react-image-gallery/styles/css/image-gallery.css";
// import { Carousel, IconButton } from "@material-tailwind/react";
// import { TbUvIndex } from "react-icons/tb";

export default function Gallery({ packageShow, packageDocReady, docId }) {
  const [images, setImages] = useState([]);
  const [toggler, setToggler] = useState(false);

  useEffect(() => {
    (async () => {
      const colRef = collection(db, "images");
      const q = query(
        colRef,
        where("adminPublish", "==", true),
        where("packages", "array-contains", docId)
      );
      const snapshots = await getDocs(q);
      const docs = snapshots.docs.map((doc) => doc.data());
      setImages(docs);
    })();
  }, [docId]);

  useEffect(() => {
    console.log("Images: ", images);
  });

  return (
    <>
      {images.length > 0 ? (
        <div className="relative md:grid md:grid-cols-2 gap-2">
          <div className="left-2 top-2 absolute z-10">
            <button
              className="bg-orange-100 border border-orange-200 mx-auto p-2 shadow-lg motion-preset-seesaw"
              onClick={() => setToggler(!toggler)}
            >
              View Gallery ({images.length})
            </button>
            <FsLightbox toggler={toggler} sources={packageShow?.images} />
          </div>
          <div className="text-white w-full mb-2 sm:mb-0">
            <img
              alt={`photographer gallery-1`}
              src={images[0]?.imageLinks?.imageKitUrl80}
              fetchpriority="high"
              className="motion-translate-y-in-100 block h-[25rem] w-full object-contain rounded-md border border-orange-500"
            />
          </div>
          <div className="grid grid-cols-2 gap-1">
            {images.slice(1, 5).map((image, index) => {
              return (
                <div
                  key={index}
                  data-cy="portfolios-div"
                  className="w-full h-full p-0 m-0"
                >
                  <img
                    src={image?.imageLinks?.imageKitUrl80}
                    alt={`photographer gallery-${index}`}
                    fetchPriority="high"
                    className="motion-translate-y-in-100 h-48 w-96 object-cover rounded-md border border-orange-500"
                  />
                  {/* <LazyLoadImage
                          alt={`photographer gallery-${index}`}
                          src={
                            image.imageDetails.resolution < 2500000
                              ? image.imageLinks.imageKitUrl50
                              : image.imageURL
                          }
                          key={image}
                          loading="lazy"
                          className="h-48 w-96 object-cover rounded-md border border-orange-500"
                          effect="blur"
                        /> */}
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div>No images</div>
      )}
    </>
  );
}
